import { EnumerationsFileType } from 'client'
import { helpers } from '@berkshireassociates/berkshirecomponents'
import type {
  IAppAcceptableFileTypes,
  IResourceLibraryIconMap,
  TFileTypeName,
  TFilename,
  TFilesWithIcons,
} from '~/constants/types/files'
import { RESOURCE_LIBRARY_ICONS } from '~/constants/icons'
import { OFileTypeNames } from '~/constants/types/files'
import {
  transformFileToFileType,
  transformFileTypeToTFileTypeName,
} from '~/utils/transforms'

export const openDownloadFileDialogWithData =
  helpers.file.openDownloadFileDialogWithData
export const openNewTabWithData = helpers.file.openNewTabWithData
export const formatBytes = helpers.file.formatBytes
export const formatAcceptTypes = helpers.file.formatAcceptTypes

export const formatFileType = (
  filetype: IAppAcceptableFileTypes
): TFileTypeName | 'Unknown' => {
  switch (filetype) {
    case 'accdb':
    case 'mdb':
      return OFileTypeNames.ACCDB
    case 'csv':
      return OFileTypeNames.CSV
    case 'doc':
    case 'docx':
      return OFileTypeNames.DOC
    case 'gif':
      return OFileTypeNames.GIF
    case 'jpeg':
    case 'jpg':
      return OFileTypeNames.JPEG
    case 'png':
      return OFileTypeNames.PNG
    case 'pdf':
      return OFileTypeNames.PDF
    case 'ppt':
    case 'pptx':
      return OFileTypeNames.PDF
    case 'rtf':
      return OFileTypeNames.RTF
    case 'svg':
      return OFileTypeNames.SVG
    case 'txt':
      return OFileTypeNames.TEXT
    case 'xls':
    case 'xlsx':
      return OFileTypeNames.EXCEL
    case 'zip':
      return OFileTypeNames.ZIP
    default:
      return 'Unknown'
  }
}

export const getFileNameFromFileType = (file: File) => {
  const fileTypeID = transformFileToFileType(file)
  return transformFileTypeToTFileTypeName(fileTypeID)
}

// converts filename into type for resource item to know what icon to show
export const getFileExtensionIconType = <T extends IAppAcceptableFileTypes>(
  filename: TFilename<T> | undefined
): TFilesWithIcons => {
  const extension = filename?.split('.').pop()?.toLowerCase()

  switch (extension) {
    case 'mp4':
      return 'mov'
    case 'pdf':
      return 'pdf'
    case 'xlsx':
    case 'xls':
    case 'csv':
      return 'excel'
    default:
      return 'generic'
  }
}

export const getFileTypeIconType = (fileType: EnumerationsFileType) => {
  switch (fileType) {
    case EnumerationsFileType.MP4:
      return 'mov'
    case EnumerationsFileType.PDF:
      return 'pdf'
    case EnumerationsFileType.CSV:
    case EnumerationsFileType.Excel:
      return 'excel'
    default:
      return 'generic'
  }
}

export const getFileIcon = (type: TFilesWithIcons) => {
  const icons: IResourceLibraryIconMap = {
    excel: RESOURCE_LIBRARY_ICONS.EXCEL_FILE,
    pdf: RESOURCE_LIBRARY_ICONS.PDF_FILE,
    mov: RESOURCE_LIBRARY_ICONS.VIDEO_FILE,
    generic: RESOURCE_LIBRARY_ICONS.GENERIC_FILE,
  }
  return icons[type]
}

export const isFilePreviewable = (fileType: EnumerationsFileType) => {
  if (
    fileType === EnumerationsFileType.PDF ||
    fileType === EnumerationsFileType.MP4
  ) {
    return true
  }
  return false
}
